/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\PartnerService\PartnerService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 4th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday July 4th 2023 10:03:50 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { PartnerSendType, PartnerType } from "Type/partner.type";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

class PartnerService {
    static async getAllPartners() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARTNERS}`;
        const myPartners = await Axios.get(myUrl, buildAxiosHeader());
        return myPartners.data;
    }

    static async CreatePartner(data: PartnerSendType) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARTNERS}`;
        const myRet = await Axios.post(myUrl, data, buildAxiosHeader());
        return myRet;
    }

    static async UpdatePartner(data: PartnerType) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARTNERS}`;
        const myRet = await Axios.put(myUrl, data, buildAxiosHeader());
        return myRet;
    }

    static async deletePartner(partnerID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARTNERS}/${partnerID}`;
        try {
            const myRet = await Axios.delete(myUrl, buildAxiosHeader());
            return myRet.data;
        } catch (error: any) {
            return error.request.status;
        }
    }

    static async getPartnersInfo() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARTNERINFO}`;
        const myRet = await Axios.get(myUrl, buildAxiosHeader());
        return myRet.data;
    }
}

export default PartnerService;
